import { useState, useEffect } from "react";

function ProjectSelector({
	labor,
	setLabor,
	sqFeet,
	setSqFeet,
	project,
	setProject,
	setProject2,
}) {
	const ProjectSelectorInput = () => {
		const [selectedClient, setSelectedClient] = useState([]);

		function handleSelectChange(event) {
			let proj = parseInt(event.target.value);
			setProject(proj);
			setProject2(proj + 1);
		}

		return (
			<div className="d-flex justify-content-center " id="substrate-selector">
				<div className="col-xs-2 label-left ">
					<label htmlFor="labor-input">Substrate</label>
				</div>
				<select
					value={project}
					onChange={handleSelectChange}
					className="form-select form-control selectboxit-optout"
				>
					<option value="0">Concrete Masonry Units or Concrete</option>
					<option value="2">Cement Backer Board Substrate</option>
				</select>
			</div>
		);
	};

	function SquareFtInput() {
		const [name, setName] = useState("");

		function handleChange(e) {
			setName(parseFloat(e.target.value));
			setSqFeet(e.target.value);
		}

		return (
			<div className="d-flex justify-content-center" id="totalft-input">
				<div className="col-xs-2 label-left ">
					<label htmlFor="total-wall">Total Wall Area</label>
				</div>
				<div className="col-xs-2 label-left input-group">
					<input
						id="total-wall"
						className="form-control "
						type="number"
						onChange={handleChange}
						value={sqFeet}
					/>
					<div className="input-group-append">
						<span className="input-group-text">ft²</span>
					</div>
				</div>
			</div>
		);
	}
	function LaborInput() {
		const [name, setName] = useState("");

		function handleChange(e) {
			setName(parseFloat(e.target.value));
			setLabor(parseFloat(e.target.value));
		}

		return (
			<div className="d-flex justify-content-center" id="labor-rate-input">
				<div className="col-xs-2 label-left ">
					<label htmlFor="labor-input">Hourly Labor Rate</label>
				</div>
				<div className="col-xs-2 label-left input-group">
					<div className="input-group-prepend">
						<span className="input-group-text">$</span>
					</div>
					<input
						id="labor-input"
						type="number"
						className="form-control"
						onChange={handleChange}
						value={labor}
					/>
				</div>
			</div>
		);
	}

	return (
		<div id="project-selector">
			<div className="content">
				<h3> Plan Your Project</h3>
				<div className="row">
					<div className="col-lg-4">{ProjectSelectorInput()}</div>
					<div className="col-lg-4">{SquareFtInput()}</div>
					<div className="col-lg-4">{LaborInput()}</div>
				</div>
			</div>
		</div>
	);
}
export default ProjectSelector;
